<script setup lang="ts">
import { useRouter } from "vue-router";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import Navbar from "./../home/repeat/Navbar.vue";
import { ref, computed } from "vue";

// 导入图片资源
import dazhong from "./../../../public/dazhong.jpg";
import haohua from "./../../../public/haohua.jpg";
import xinneng from "./../../../public/xinneng.jpg";
import { useI18n } from "vue-i18n";

const router = useRouter();
const { t } = useI18n();

// 用 computed 来包装 items，使其在语言切换时自动更新
const items = computed(() => [
  {
    imgSrc: dazhong,
    title: t("system.about.quality.item_a"),
  },
  {
    imgSrc: haohua,
    title: t("system.about.quality.item_b"),
  },
  {
    imgSrc: xinneng,
    title: t("system.about.quality.item_c"),
  },
]);

// 定义当前悬停项索引的状态
const hoveredIndex = ref(-1);

// 用于处理鼠标悬停事件的函数
const handleMouseOver = (index: number) => {
  hoveredIndex.value = index;
};

// 用于处理鼠标移出事件的函数
const handleMouseOut = () => {
  hoveredIndex.value = -1;
};
</script>

<template>
  <div class="quality">
    <div class="main">
      <div class="kong">
        <Header> </Header>
      </div>
      <div class="img_box">
        <div class="img_text">
          <div class="img_inner">
            <h2>{{ $t("system.about.quality.inner_h") }}</h2>
            <div class="img_main">
              <div>{{ $t("system.about.quality.main_d") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="wrap_title">
          <div class="title_box">
            <div class="title">
              <a class="no" href="/">{{ $t("system.home.menu.home") }}</a>
              <text>></text>
              <a class="th">{{ $t("system.home.menu.qualityControl") }}</a>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box_o">
            <div class="box_o_inner">
              <div class="inner_text">
                <div class="text_tit">
                  {{ $t("system.about.quality.tit") }}
                </div>
              </div>
              <div class="box_o_img">
                <img src="./../../assets/imgs/zhongyi.png" alt="" />
              </div>
            </div>
          </div>
          <div class="box_t">
            <div class="box_t_inner">
              <div class="t_inner">
                <div class="inner_left">
                  <img src="./../../assets/imgs/shouquan.png" alt="" />
                </div>
                <div class="inner_right">
                  {{ $t("system.about.quality.right") }}
                </div>
              </div>
              <div class="b_inner">
                <!-- 循环浏览项目并应用悬停效果-->
                <div
                  class="b_inner_o"
                  v-for="(item, index) in items"
                  :key="index"
                  @mouseover="handleMouseOver(index)"
                  @mouseout="handleMouseOut"
                  :class="{ hovered: hoveredIndex === index }"
                >
                  <!-- 每个项目的内容-->
                  <div class="o_wrap">
                    <div class="wrap_img">
                      <img :src="item.imgSrc" alt="" />
                    </div>
                    <div class="wrap_h">{{ item.title }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"> </Navbar>
  </div>
</template>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.main {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.kong {
  max-width: 1200px;
  height: 120px;
}
.img_box {
  width: 100%;
  height: 553px;
  position: relative;
  background-image: url("./../../../public/zl.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100% 100%;
}
.img_text {
  width: 1519px;
  height: 173px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
  line-height: 1.25;
}
.img_inner {
  align-items: center;
  width: 1230px;
  padding: 0 15px;
  height: 173px;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}
.img_main {
  align-items: center;
  width: 100%;
  height: auto;
  font-size: 32px;
  line-height: 1.72;
  margin-top: 20px;
}
h2 {
  width: 100%;
  font-size: 46px;
  height: 50px;
  padding: 0;
  font-weight: bold;
  color: #20538c;
  margin: 0;
}
.wrap {
  width: 100%;
  height: auto;
}
.wrap_title {
  padding: 30px 0;
  width: 100%;
  color: #3e3a39;
  background-color: #fff;
  font-size: 14px;
  height: 26px;
}
.title_box {
  width: 100%;
  max-width: 1230px;
  padding: 0 15px;
  margin: 0 auto;
}
.title {
  width: 100%;
  height: 100%;
  font-size: 18px;
  margin: 0 -8px;
}
.title a {
  display: inline-block;
  padding: 0 8px;
  font-weight: bold;
  color: #696b71;
}
.box {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 40px 0 20px;
}
.box_0 {
  position: relative;
  width: 100%;
  height: 558px;
  padding: 50px 0;
  background-attachment: local;
  background: 50% 0 no-repeat fixed;
  background-size: cover;
}
.box_o_inner {
  width: 1230px;
  height: 458px;
  max-width: 1230px;
  margin: 0 auto;
  padding: 0 15px;
}
.box_o .box_o_inner {
  display: flex;
  align-items: center;
  min-height: 450px;
}
.inner_text {
  width: 600px;
  width: 50%;
  height: auto;
  margin-left: 0;
}
.text_tit {
  line-height: 1.5;
  font-size: 24px;
  font-weight: bold;
}
.box_o_img {
  width: 50%;
  text-align: center;
}
.box_o_img img {
  border: none;
  display: inline-block;
  max-width: 100%;
  height: auto;
  transform: translateX(14%);
}
.box_t {
  width: 100%;
  background-color: #fff;
  height: auto;
  padding-top: 60px;
  box-sizing: border-box;
}
.box_t_inner {
  width: 1230px;
  max-width: 1230px;
  height: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 15px;
}
.t_inner {
  width: 100%;
  height: 320px;
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 40px;
}
.inner_left {
  width: 50%;
  height: 100%;
}
.inner_right {
  height: auto;
  flex: 1 0 0;
  font-size: 16px;
  overflow: hidden;
  padding: 0 50px;
  line-height: 1.875;
}
.b_inner {
  width: 100%;
  height: 404px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  flex-wrap: wrap;
  align-items: stretch;
}
.b_inner_o {
  position: relative;
  width: 33%;
  transition: transform 0.8s ease;
}
.o_wrap {
  height: 100%;
  padding: 40px -1px 0;
}
.wrap_text {
  width: 312px;
  margin: 0 auto;
  line-height: 28px;
  max-height: 224px;
  height: 224px;
}
.wrap_img {
  width: 100%;
  height: 100%;
}
.wrap_h {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  clear: both;
  font-size: 24px;
  height: 52px;
  padding: 13px 30px;
  background: #1f5368;
  color: #ffffff;
  font-weight: bold;
  box-sizing: border-box;
}
.hovered {
  transform: translateY(-20px);
}
</style>
